<div class="question-wrapper-true vertical-view-radio" *ngIf="displayMode == 'Vertical'">
  <div class="div-content sentence-align">
    <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>

  <mat-radio-group name="radioButtons" class="smallRadio">
    <div class="div-options sentence-align" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
      <mat-radio-button [disabled]='isReadOnly' [value]="true" [checked]="o?.answerValid" class="options">
        <ng-component class="editor-radio" [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
      </mat-radio-button>
    </div>
  </mat-radio-group>

</div>

<div class="question-wrapper-true horizontal-view-radio" *ngIf="displayMode == 'Horizontal'">
  <div class="col-w-40">
    <div class="div-content">
      <ng-component class="editor-question"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
    </div>
  </div>
  <div class="col-w-60">
    <mat-radio-group name="radioButtons" class="smallRadio">
      <div class="div-options" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
        <mat-radio-button [disabled]='isReadOnly' [value]="true" [checked]="o?.answerValid" class="options">
          <ng-component class="editor-radio" [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <!-- <div class="div-content">
    <ng-component class="editor-question"
      [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>
  <div style="width: 325px; display: flex; justify-content: center; ">
    <mat-radio-group name="radioButtons" class="smallRadio">
      <div class="div-options" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
        <mat-radio-button [disabled]='isReadOnly' [value]="true" [checked]="o?.answerValid" class="options">
          <ng-component class="editor-radio" [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div> -->
</div>
